import React, { useState, useEffect } from "react";
import _ from 'i18n';
import { Col, Row } from "antd";
import { formatAmount } from "../../../../services/utils";

const CongressDetails = ({ data, type }) => {

  const [payingPersonsTotal, setPayingPersonsTotal] = useState(0);
  const [notPayingPersonsTotal, setNotPayingPersonsTotal] = useState(0);
  const [packGuests, setPackGuests] = useState(0);
  const [packQuantities, setPackQuantities] = useState(0);
  const [packsHTVA, setPacksHTVA] = useState(0);
  const [packsTVAC, setPacksTVAC] = useState(0);


  const calculateTotalsByRegistrantType = () => {
    let payingPersonsTotal = 0;
    let notPayingPersonsTotal = 0;
    let packGuests = 0;
    let packQuantities = 0;
    let packsHTVA = 0;
    let packsTVAC = 0;

    data.forEach(element => {
      if (type === 'pack') {
        packGuests += element.packGuests;
        packQuantities += element.nbrAchat;
        packsTVAC += element.sumAmount;
        packsHTVA += element.sumAmountHTVA;
      } else {
        payingPersonsTotal += element.payingPersons;
        notPayingPersonsTotal += element.notPayingPersons;
      }

    });

    setPayingPersonsTotal(payingPersonsTotalCalc);
    setNotPayingPersonsTotal(notPayingPersonsTotalCalc);
    setPackGuests(packGuestsCalc);
    setPackQuantities(packQuantitiesCalc);
    setPacksHTVA(packsHTVACalc);
    setPacksTVAC(packsTVACCalc);

  };



  const renderDetailsRows = () => {

    const detailsRows = data.map((line, index) => {

      if (line.nbrAchat != 0 || line.packGuests != 0) {
        return (
          <Row className={'congress-details-row font-medium'}>
            <Col span={type === 'pack' ? 8 : 12}>
              <div>{line.name}</div>
              <div className={'font-normal'}>{(line.startDate === line.endDate || line.endDate == null) ? line.startDate : ('Du ' + line.startDate + ' au ' + line.endDate)}</div>
            </Col>
            <Col span={4}>{type === 'pack' ? line.nbrAchat : line.payingPersons}</Col>
            <Col span={4}>{type === 'pack' ? line.packGuests : line.notPayingPersons}</Col>
            <Col span={4}>{type === 'pack' ? formatAmount(line.sumAmountHTVA) : line.payingPersons + line.notPayingPersons}</Col>
            {type === 'pack' && <Col span={4}>{formatAmount(line.sumAmount)}</Col>}
          </Row>
        );
      }
      return null;
    });
    return detailsRows;
  };

  // componentDidMount
  useEffect(() => {
    calculateTotalsByRegistrantType();
  }, []);

  return (
    <div className={'congress-details'}>
      <div className={'mb-3'}>{type === 'pack' ? _('COMPANY_PACKS') : _('INDIVIDUAL_FORMULAS')}</div>
      <Row className={'congress-details-row font-normal'} align="middle">
        <Col span={type === 'pack' ? 8 : 12} />
        <Col span={4}>{type === 'pack' ? _('quantity') : _('PAYING')}</Col>
        <Col span={4}>{type === 'pack' ? _('GUESTS') : _('FREE')}</Col>
        <Col span={4}>{type === 'pack' ? _('HTVA') : _('TOTAL')}</Col>
        {type === 'pack' && <Col span={4}>{_('TVAC')}</Col>}
      </Row>
      {data && data.length > 0 && renderDetailsRows()}
      <Row className={'congress-details-row font-medium'}>
        <Col span={type === 'pack' ? 8 : 12} />
        <Col span={4}>{type === 'pack' ? packQuantities : payingPersonsTotal}</Col>
        <Col span={4}>{type === 'pack' ? packGuests : notPayingPersonsTotal}</Col>
        <Col span={4}>{type === 'pack' ? formatAmount(packsHTVA) : payingPersonsTotal + notPayingPersonsTotal}</Col>
        {type === 'pack' && <Col span={4}>{formatAmount(packsTVAC)}</Col>}
      </Row>
    </div>
  );
};

export default CongressDetails;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/Congress/CongressDetails.js